export const MobileTermsLink = ({ testId, newTab = false, className = "" }) => (
  <a href="/mobile-terms/" target={newTab ? "_blank" : undefined} rel={newTab ? "noopener noreferrer" : undefined}
    className={`underline underline-offset-4 transition-opacity hover:opacity-70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 ${className}`}
    data-testid={testId}>Mobile Terms{newTab && <span className="sr-only"> (opens in a new tab)</span>}</a>
);